export const getPreviewImageUrl = (file: File | Blob): Promise<string> => {
  const previewUrl = URL.createObjectURL(file);
  return Promise.resolve(previewUrl);
};
